
import React, {
  PropTypes
} from 'react';

import {
  Button
} from 'react-bootstrap';

import { animateScroll } from 'react-scroll';
import FA from 'react-fontawesome';

const NextSectionButton = ({
  targetID,
  offset = 50,
  className = null,
  angleIcon = 'down',
  children = null,
  bsStyle = 'default',
  bsSize = 'large',
  title = null
} = {} ) => (
  <Button
    title={title || targetID}
    className={className}
    bsStyle={bsStyle}
    bsSize={bsSize}
    style={{
      border: 'transparent',
      color: '#fff',
      margin: 'auto'
    }}
    onClick={() => {
      const pos = document.getElementById(targetID).offsetTop;
      // // ... no animation
      // // window.scrollTo(0, pos - 50);
      // animateScroll.scrollTo(pos - 50, {
      //   duration: 640,
      //   // delay: 100,
      //   // smooth: true
      // });

      animateScroll.scrollTo(pos - offset, {
        duration: 640,
        // delay: 100,
        // smooth: true
      });
    }}
  >
    {children ? children : <
      FA name={ `angle-double-${angleIcon}` } className="animated"
    />}
  </Button>
);

NextSectionButton.propTypes = {
  targetID: PropTypes.string.isRequired,
  offset: PropTypes.number,

  className: PropTypes.string,
  angleIcon: PropTypes.string,
  children: PropTypes.any,
  bsStyle: PropTypes.string,
  bsSize: PropTypes.string,
  title: PropTypes.string
};

export default NextSectionButton;



// WEBPACK FOOTER //
// ./src/components/common/NextSectionButton.js